import { type ProviderOffer, type UnknownProviderOffer } from "../../../../../types/dtos/api/sales/provider-offer.dto";
import { type OfferPricingEvaluationContext, type ProviderPricingEvaluation } from "../OfferPricing.types";
import { BaseOfferPricingProvider } from "../OfferPricingProvider.contract";

export class UnknownOfferPricingProvider extends BaseOfferPricingProvider {

    /**
     * Creates the unknown-provider pricing plugin.
     */
    public constructor() {
        super( "unknown" );
    }

    /**
     * Returns provider-only metadata for unknown providers.
     *
     * @param _ Segment context (unused for this provider).
     * @param providerOffer Raw provider payload.
     * @returns Normalized provider evaluation with no price and no booking URL.
     */
    public evaluate( _: OfferPricingEvaluationContext, providerOffer: ProviderOffer ): ProviderPricingEvaluation {
        const typedOffer = providerOffer as UnknownProviderOffer;

        return {
            "providerKey":  typedOffer.provider,
            "providerName": this.getProviderLabel(),
            "price":        null,
            "bookingUrl":   null,
        };
    }

}

export const unknownOfferPricingProviderPlugin = new UnknownOfferPricingProvider();
